export enum enmOfferAnswerType {
    Watch = 0,
    Send = 1,
    Ignore = 2,
    Result = 3,
    None = 4
}